module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_fondo_10.71434ce4.png";